const API_URL = process.env.REACT_APP_API_URL;
const SETTINGS_URL = `${API_URL}/api/settings`;
const MEMORY_URL = `${API_URL}/api/memory`;

export async function fetchSettings(type = 'all') {
    try {
        const response = await fetch(`${SETTINGS_URL}?type=${type}`, {
            method: 'GET',
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch settings');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching settings:', error);
        throw error;
    }
}

export async function updateSettings(newSettings) {
    try {
        const response = await fetch(SETTINGS_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(newSettings),
        });

        if (!response.ok) {
            throw new Error('Failed to update settings');
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating settings:', error);
        throw error;
    }
}

export async function fetchUserMemories({ agentId = null, limit = 100, offset = 0 } = {}) {
    try {
        const params = new URLSearchParams();
        if (agentId) params.set('agentId', agentId);
        if (limit) params.set('limit', String(limit));
        if (offset) params.set('offset', String(offset));
        const response = await fetch(`${MEMORY_URL}?${params.toString()}`, {
            method: 'GET',
            credentials: 'include',
        });
        if (!response.ok) throw new Error('Failed to fetch memories');
        return await response.json();
    } catch (error) {
        console.error('Error fetching memories:', error);
        throw error;
    }
}

export async function deleteUserMemory(id, { agentId = null } = {}) {
    try {
        const params = new URLSearchParams();
        if (agentId) params.set('agentId', agentId);
        const response = await fetch(`${MEMORY_URL}/${encodeURIComponent(id)}?${params.toString()}`, {
            method: 'DELETE',
            credentials: 'include',
        });
        if (!response.ok) throw new Error('Failed to delete memory');
        return await response.json();
    } catch (error) {
        console.error('Error deleting memory:', error);
        throw error;
    }
}
